var map = {
	"./swedbankpay-logo-h-neg.png": 33269,
	"./swedbankpay-logo-h-neg.svg": 21650,
	"./swedbankpay-logo-h.png": 19056,
	"./swedbankpay-logo-h.svg": 43071,
	"./swedbankpay-logo-v-neg.png": 75044,
	"./swedbankpay-logo-v-neg.svg": 31610,
	"./swedbankpay-logo-v.png": 56601,
	"./swedbankpay-logo-v.svg": 17245
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90982;